import { Autocomplete, Box, FormControl, InputLabel, MenuItem, Stack, Typography, Table } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"
import ActionsBar from '../../../components/ActionsBar';
import { FilterAlt } from '@mui/icons-material'
import Button from '@mui/material/Button';
import PermissionDetailItem from './components/PermissionDetailItem';
import Paper from '@mui/material/Paper'
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { authAtom, tokenAtom } from '../../../actions';
import { useAtom, useAtomValue } from 'jotai';
import axios from 'axios'
import { toast } from 'react-toastify';
import { ALL_PERMISSIONS, hasPermission } from '../../../utils/utils';

// crm_access,management_access,view_report,view_report_all,create_new_lead,view_lead,view_lead_all,write_lead_all,assign_lead,view_group_all,view_group,view_order,view_customer_all,view_customer,view_order_all,view_comission,write_payment,view_payment_all,view_payment,view_comission_all,write_comission,export_report_all,export_report_customer,export_report_order,export_report_payment,export_report_comission

const Screen = () => {
    const { username: staff_username } = useParams()
    const token = useAtomValue(tokenAtom)
    const [user, setUser] = useState({})
    const [permissions, setPermissions] = useState([])
    const [auth] = useAtom(authAtom)

    const getPermissions = useCallback(() => {
        if (token) {
            axios.post('/accounts/customers/get_permission/', {
                username: staff_username,
            }, {
                headers: {
                    'Authorization': `Token ${token}`
                }
            })
                .then((response) => {
                    if (response && response.data) {
                        setUser(response.data)
                        setPermissions(response.data.permissions ?? [])
                    } else {
                        setUser({})
                        setPermissions([])
                    }
                })
                .catch((error) => {
                    console.log({ error })
                    setUser({})
                    setPermissions([])
                })
        }
    }, [staff_username, token])

    useEffect(() => {
        getPermissions()
    }, [getPermissions])

    const onChangePermission = (permission, checked) => {
        console.log({ permission, checked })
        if (permission === 'crm_access' && !checked) {
            setPermissions([])
        } else {
            let newPermissions = [...permissions]
            const index = newPermissions.indexOf(permission)
            if (index >= 0) {
                newPermissions.splice(index, 1)
            }

            if (checked) {
                newPermissions.push(permission)
            }

            setPermissions(newPermissions)
        }
    }

    const onSave = () => {
        axios.post('/accounts/customers/update_permission/', {
            username: staff_username,
            permissions
        }, {
            headers: {
                'Authorization': `Token ${token}`
            }
        })
            .then((response) => {
                if (response && response.data) {
                    toast.success('Cập nhật thành công')
                } else {
                    toast.error('Cập nhật thất bại')
                }
            })
            .catch((error) => {
                console.log({ error })
                toast.error('Cập nhật thất bại')
            })
    }

    if(!(auth && hasPermission(auth, ['management_access']))) {
        return <Stack sx={{flex: 1, alignItems: 'center', justifyContent: 'center', margin: '32px'}}>Không có quyền truy cập</Stack>
    }

    return (
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', width: '100%' }}>
            <Stack sx={{ margin: '16px', gap: '32px' }}>
                <Stack direction='row' justifyContent='space-between' alignItems='center'>
                    <h4>{`Chi tiết phân quyền - ${user.full_name ?? ''} - ${user.username ?? ''}`}</h4>
                    <Button onClick={onSave} sx={{ height: '50px' }} variant='contained'>Lưu thay đổi</Button>
                </Stack>
                <Stack>
                    {ALL_PERMISSIONS.map((group) => (
                        <>
                            <Stack direction='row' sx={{ background: 'black', justifyContent: 'space-between', padding: '16px 8px' }}>
                                <Typography sx={{ color: 'white', width: '110px', alignItems: 'center', textAlign: 'center' }}></Typography>
                                <Typography sx={{ color: 'white', flex: 1 }}>{group.title}</Typography>

                            </Stack>
                            {
                                group.items.map((permission) => (
                                    <PermissionDetailItem
                                        permission={permission}
                                        access={permissions}
                                        onChange={(checked) => onChangePermission(permission.permission, checked)}
                                    />
                                ))
                            }
                        </>
                    ))}
                </Stack>
            </Stack>
        </div>
    )
}

export default Screen